import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import $ from 'jquery';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  public menuItems: any = [];
  bucketurl = environment.bucketUrl;
  constructor(private router: Router, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
    this.document.body.classList.add('logged-in-background');
    this.selectedTarget = this.router.url.split("/")[2]
  }

  selectedTarget: any = ''
  setActive(TARGETNAME: any): void {
    this.selectedTarget = TARGETNAME;
    let spliedClass: any = document.getElementById(TARGETNAME)?.className.split(" ")
    if (spliedClass[2] == 'active' || spliedClass[3] == 'active') {
      document.getElementById(TARGETNAME)!.classList.remove("active");
    }
    else {
      document.getElementById(TARGETNAME)!.classList.add('active');
    }
  }

  isCollapsed: boolean = false;
  $: any;
  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    $("body").toggleClass("fullcontent");
    setTimeout(()=>{
      window.dispatchEvent(new CustomEvent('resize'))
    },50)
  }
}
